import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { BaseEntityResolver } from './resolver.helper';
import { OAuthTokenActionTypes } from '../State/actions/o-auth-token.actions';
import { getOAuthTokenFetched } from '../State/selectors/o-auth-token.selector';

@Injectable({
    providedIn: 'root',
})
export class OAuthTokenResolver extends BaseEntityResolver {
    constructor(store: Store<State>) {
        super(getOAuthTokenFetched, OAuthTokenActionTypes.Load(), store);
    }
}
